import * as tslib_1 from "tslib";
import { OnInit, ElementRef, TemplateRef } from '@angular/core';
import { Urls } from '@root/utils/urls';
import { Something_went_wrong } from '@root/app.constant';
export class BlogsComponent {
    constructor(router, modalService, blogService, apiService, toastr, downloadFileService, commonDataService) {
        this.router = router;
        this.modalService = modalService;
        this.blogService = blogService;
        this.apiService = apiService;
        this.toastr = toastr;
        this.downloadFileService = downloadFileService;
        this.commonDataService = commonDataService;
        this.modalTarget = '#infographics-modal';
        this.showVideoPopup = false;
        this.videoId = '';
        this.loadingVideo = true;
        this.activeTab = 'watch';
        this.formData = {
            name: "",
            emailId: "",
            mobileNumber: "",
            comment: "",
        };
    }
    ngOnInit() {
        this.commonDataService.loaderStatus.next(true);
        this.apiService.getData(Urls.getIapPageTextForAllSections).subscribe((response) => {
            console.log(response);
            if (response && response.data.returnValueList) {
                this.organizedSections = {};
                // Iterate through each item in returnValueList
                response.data.returnValueList.forEach((item) => {
                    const sectionName = item.sectionName;
                    this.organizedSections[sectionName] = item;
                });
            }
            this.commonDataService.loaderStatus.next(false);
        }, (error) => {
            this.showArrow = false;
            if (error.error.errorMessage === null || error.errorMessage === '') {
                this.toastr.error(Something_went_wrong);
            }
            else {
                this.toastr.error(error.error.errorMessage);
            }
            this.commonDataService.loaderStatus.next(false);
        });
        this.blogService.setActiveTab(this.activeTab);
        this.getBanners();
        this.getVideos();
    }
    backToHome() {
        this.router.navigate(['/home'], {
            state: { previousUrl: this.router.url },
        });
    }
    goToSection(divId) {
        const element = document.getElementById(divId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
    scrollRight() {
        if (this.activeTab === 'watch') {
            const videoRowEl = this.videoRow.nativeElement;
            const scrollAmount = videoRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
            videoRowEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
        else if (this.activeTab === 'infographics') {
            const infoRowEl = this.infoRow.nativeElement;
            const scrollAmount = infoRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
            infoRowEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
        else {
            const readRowEl = this.readRow.nativeElement;
            const scrollAmount = readRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
            readRowEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    }
    scrollLeft() {
        if (this.activeTab === 'watch') {
            const videoRowEl = this.videoRow.nativeElement;
            const scrollAmount = videoRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
            videoRowEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
        else if (this.activeTab === 'infographics') {
            const infoRowEl = this.infoRow.nativeElement;
            const scrollAmount = infoRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
            infoRowEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
        else {
            const readRowEl = this.readRow.nativeElement;
            const scrollAmount = readRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
            readRowEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
        // const blogsRowEl = this.blogsRow.nativeElement as HTMLElement;
        // const scrollAmount = blogsRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
        // blogsRowEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
    extractYoutubeVideoId(url) {
        try {
            const parsedUrl = new URL(url);
            // Handle youtu.be short links
            if (parsedUrl.hostname.includes("youtu.be")) {
                this.isShort = false;
                return parsedUrl.pathname.slice(1);
            }
            // Handle Shorts
            if (parsedUrl.pathname.startsWith("/shorts/")) {
                this.isShort = true;
                return parsedUrl.pathname.split("/")[2] || parsedUrl.pathname.split("/")[1];
            }
            // Handle regular watch?v=
            const videoId = parsedUrl.searchParams.get("v");
            this.isShort = false;
            if (videoId)
                return videoId;
            // Handle embed
            if (parsedUrl.pathname.startsWith("/embed/")) {
                this.isShort = false;
                return parsedUrl.pathname.split("/")[2];
            }
            return null;
        }
        catch (error) {
            console.error("Invalid YouTube URL:", url);
            return null;
        }
    }
    generateThumbnail(video) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const videoId = this.extractYoutubeVideoId(video.youtubeLink);
            if (!videoId) {
                // this.toastr.error('Invalid YouTube URL. Please try with a valid video link.');
                return;
            }
            const resolutions = ["maxresdefault", "hqdefault", "mqdefault", "default"];
            let foundThumbnail = false;
            for (let res of resolutions) {
                const url = `https://img.youtube.com/vi/${videoId}/${res}.jpg`;
                try {
                    const response = yield fetch(url, { method: "HEAD" }); // Check if image exists
                    if (response.ok) {
                        video.thumbnail = url; // Assign the first valid image
                        foundThumbnail = true;
                        return;
                    }
                }
                catch (error) {
                    console.error(`Failed to fetch ${url}`, error);
                }
            }
            // If no valid thumbnail is found, set to maxresdefault as the last resort
            if (!foundThumbnail) {
                video.thumbnail = 'assets/images/default-video-placeholder.jpg';
            }
        });
    }
    openModal(content) {
        this.modalService.open(content, {
            size: "lg",
            windowClass: "align-modal-center custom-modal-width",
        });
    }
    onTabChange(tabId) {
        this.activeTab = tabId;
        this.blogService.setActiveTab(tabId);
        if (this.activeTab === 'watch') {
            this.getVideos();
        }
        else if (this.activeTab === 'infographics') {
            this.getInfographics();
        }
        else if (this.activeTab === 'read') {
            this.getBlogs();
        }
    }
    viewAllBlogs() {
        this.router.navigate(['/blogs/view-all', this.activeTab]);
    }
    closePopup(modal) {
        modal.close(); // Close the modal
    }
    getBanners() {
        this.commonDataService.loaderStatus.next(true);
        this.apiService.getData(Urls.getIapPageBanners).subscribe((response) => {
            this.BannerList = response.data.banners;
            this.commonDataService.loaderStatus.next(false);
        }, (error) => {
            if (error.error.errorMessage === null || error.errorMessage === '') {
                this.toastr.error(Something_went_wrong);
            }
            else {
                this.toastr.error(error.error.errorMessage);
            }
            this.commonDataService.loaderStatus.next(false);
        });
    }
    getVideos() {
        this.commonDataService.loaderStatus.next(true);
        this.apiService.getData(Urls.getIapPageVideos).subscribe((response) => {
            this.videoList = response.data.videos;
            this.showArrow = this.videoList && this.videoList.length > 3 || false;
            // this.videoList.map(video=>{
            //   this.generateThumbnail(video)
            // })
            this.commonDataService.loaderStatus.next(false);
        }, (error) => {
            this.showArrow = false;
            if (error.error.errorMessage === null || error.errorMessage === '') {
                this.toastr.error(Something_went_wrong);
            }
            else {
                this.toastr.error(error.error.errorMessage);
            }
            this.commonDataService.loaderStatus.next(false);
        });
    }
    getInfographics() {
        this.commonDataService.loaderStatus.next(true);
        this.apiService.getData(Urls.getIapPageInfographics).subscribe((response) => {
            this.infographicList = response.data.infographics;
            this.showArrow = this.infographicList && this.infographicList.length > 3 || false;
            this.commonDataService.loaderStatus.next(false);
        }, (error) => {
            this.showArrow = false;
            if (error.error.errorMessage === null || error.errorMessage === '') {
                this.toastr.error(Something_went_wrong);
            }
            else {
                this.toastr.error(error.error.errorMessage);
            }
            this.commonDataService.loaderStatus.next(false);
        });
    }
    getBlogs() {
        this.commonDataService.loaderStatus.next(true);
        this.apiService.getData(Urls.getIapPageBlogs).subscribe((response) => {
            this.blogList = response.data.blogs;
            this.showArrow = this.blogList && this.blogList.length > 3 || false;
            console.log(this.showArrow);
            this.commonDataService.loaderStatus.next(false);
        }, (error) => {
            this.showArrow = false;
            if (error.error.errorMessage === null || error.errorMessage === '') {
                this.toastr.error(Something_went_wrong);
            }
            else {
                this.toastr.error(error.error.errorMessage);
            }
            this.commonDataService.loaderStatus.next(false);
        });
    }
    viewBlogPage(id) {
        this.router.navigate(['/blogs/view', id]);
    }
    redirectToSocialMedia(shareIcon, file) {
        const imageUrl = file;
        const text = "Check out this!\n";
        let url = "";
        switch (shareIcon) {
            case 1: // Facebook
                url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(imageUrl)}`;
                break;
            case 2: // Instagram
                url = "https://www.instagram.com/";
                break;
            case 3: // Twitter
                url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(imageUrl)}`;
                break;
            case 4: // WhatsApp
                url = `https://wa.me/?text=${encodeURIComponent(text + " " + imageUrl)}`;
                break;
            default:
                url = "";
        }
        if (url) {
            window.open(url, "_blank");
        }
    }
    submitForm(form) {
        if (form.invalid) {
            alert("Please fill all the required fields correctly.");
            return;
        }
        this.commonDataService.loaderStatus.next(true);
        this.apiService.postData(Urls.knowMoreAboutMF, this.formData).subscribe((response) => {
            // this.toastr.success("Form submitted successfully");
            this.toastr.info(response.message, "", {
                enableHtml: true,
                timeOut: 5000,
            });
            this.commonDataService.loaderStatus.next(false);
            form.resetForm();
        }, (error) => {
            if (error.error.errorMessage === null || error.errorMessage === '') {
                this.toastr.error(Something_went_wrong);
            }
            else {
                this.toastr.error(error.error.errorMessage);
            }
            this.commonDataService.loaderStatus.next(false);
        });
    }
    downloadFile(path) {
        const fileName = path.split("/").pop();
        this.downloadFileService.export(path).subscribe(path => saveAs(path, fileName));
    }
    viewClickableUrlPage(clickableUrl) {
        if (clickableUrl && clickableUrl.length > 0 && clickableUrl !== 'null') {
            const isRelativePath = clickableUrl.indexOf('http') === -1;
            isRelativePath ? this.router.navigateByUrl(clickableUrl) : window.open(clickableUrl, "_blank");
        }
    }
    openVideo(youtubeUrl) {
        const videoId = this.extractYoutubeVideoId(youtubeUrl);
        if (!videoId) {
            this.toastr.error('Invalid YouTube URL. Please try with a valid video link.');
            return;
        }
        this.videoId = videoId;
        this.loadingVideo = true;
        this.showVideoPopup = true;
    }
    onPlayerReady(event) {
        console.log('ready');
        this.loadingVideo = false;
        const player = event.target;
        player.mute(); // Required for autoplay in most browsers
        player.playVideo();
    }
    closeVideo() {
        this.showVideoPopup = false;
        this.videoId = '';
        this.loadingVideo = false;
    }
}
